import { Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { useWorkerBookedVisitsData } from "../useWorkerBookedVisitsData";
import { InHomeHighlightedCardContent } from "./Card";

export function InHomeHighlightedBookedVisitsList() {
  const { highlightedVisits, caseIdToPatientMap } = useWorkerBookedVisitsData();

  if (isEmpty(highlightedVisits)) {
    return null;
  }

  return (
    <Stack spacing={4}>
      {highlightedVisits.map((visit) => {
        const patient = caseIdToPatientMap.get(visit.attributes.caseId);

        return <InHomeHighlightedCardContent key={visit.id} visit={visit} patient={patient} />;
      })}
    </Stack>
  );
}
